import { Box, Tooltip } from '@mui/material';
import { InfoError } from 'src/icons/info-error';

interface Props {
  tooltipTitle: string;
  visible: boolean;
  color?: string;
}

const ErrorIndicator = ({ visible, tooltipTitle, color }: Props) => {
  return visible ? (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Tooltip title={tooltipTitle}>
        <InfoError fontSize="small" sx={{ color: color ?? '#F04438' }} />
      </Tooltip>
    </Box>
  ) : null;
};

export default ErrorIndicator;
